import { useEffect, useState } from "react";
import api from "@/lib/api";
import CrudPage from "@/components/CrudPage";
import { useAuth, canWrite } from "@/context/AuthContext";
import { rupiah, num } from "@/lib/format";

export default function LaborCost() {
  const { user } = useAuth();
  const [batches, setBatches] = useState(null);
  const [workers, setWorkers] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/batches"), api.get("/labor-workers")]).then(([b, w]) => {
      setBatches(b.data);
      setWorkers(w.data);
    }).catch(() => setBatches([]));
  }, []);

  if (!batches) return <div className="text-slate-400 py-20 text-center">Memuat...</div>;
  const wmap = Object.fromEntries(workers.map((w) => [w.id, w]));

  return (
    <CrudPage
      title="Labor Cost (BTKL)"
      subtitle="Jam kerja produksi per batch dan biaya tenaga kerja langsung."
      endpoint="/labor-costs"
      canWrite={canWrite(user?.role, ["akuntansi", "admin_produksi"])}
      scope={{ key: "batch_id", placeholder: "Pilih Batch", options: batches.map((b) => ({ value: b.id, label: `${b.no_batch} — ${b.product_name}` })) }}
      columns={[
        { key: "worker_id", label: "Pekerja", render: (r) => wmap[r.worker_id]?.name || "-" },
        { key: "jam_standar", label: "Jam Std", align: "right", render: (r) => num(r.jam_standar, 1) },
        { key: "jam_aktual", label: "Jam Aktual", align: "right", render: (r) => num(r.jam_aktual, 1) },
        { key: "jam_lembur", label: "Lembur", align: "right", render: (r) => num(r.jam_lembur, 1) },
        { key: "selisih", label: "Selisih Jam", align: "right", render: (r) => num(r.jam_aktual - r.jam_standar, 1) },
        { key: "total", label: "Total BTKL", align: "right", render: (r) => rupiah(r.jam_aktual * r.tarif_upah + r.jam_lembur * r.tarif_lembur) },
      ]}
      fields={[
        { key: "worker_id", label: "Pekerja / Operator", type: "select", options: workers.map((w) => ({ value: w.id, label: `${w.name} (${w.jabatan})` })) },
        { key: "jam_standar", label: "Jam Kerja Standar", type: "number", step: "0.1" },
        { key: "jam_aktual", label: "Jam Kerja Aktual", type: "number", step: "0.1" },
        { key: "jam_lembur", label: "Jam Lembur", type: "number", step: "0.1" },
        { key: "tarif_upah", label: "Tarif Upah (Rp/jam)", type: "number" },
        { key: "tarif_lembur", label: "Tarif Lembur (Rp/jam)", type: "number" },
      ]}
    />
  );
}
